export enum Verb {
  INCLUDES = "includes",
  EXACT = "exact",
  STARTS_WITH = "starts with",
  ENDS_WITH = "ends with",
  DOES_NOT_INCLUDE = "does not include",
  DOES_NOT_EQUAL = "does not equal"
}
